import { render } from "./OpenSource.vue?vue&type=template&id=5eaa97fa&scoped=true"
import script from "./OpenSource.vue?vue&type=script&lang=js"
export * from "./OpenSource.vue?vue&type=script&lang=js"

import "./OpenSource.vue?vue&type=style&index=0&id=5eaa97fa&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eaa97fa"]])

export default __exports__